import { render, staticRenderFns } from "./BusinessEntityCreate.vue?vue&type=template&id=86b94802&"
import script from "./BusinessEntityCreate.vue?vue&type=script&lang=js&"
export * from "./BusinessEntityCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports